import { onContentReady } from "@story/story_assets";

//
// Loaded images
//
onContentReady(function(parent) {
	for (let element of parent.querySelectorAll("img.img-jpg")) {
		function loaded() {
			element.classList.remove("img-jpg");
		}

		if (element.complete) {
			loaded();
		}
		else {
			element.addEventListener("load", loaded, { once: true });
		}
	}
});